// extracted by mini-css-extract-plugin
export default {"hiddenImage":"CopilotImageHiddenComponent-module__hiddenImage--VoShI"};